import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { STRIP_CITATIONS_COMMAND } from './StripCitationsPlugin';

export const useStripCitations = () => {
  const [editor] = useLexicalComposerContext();

  return useCallback(() => {
    editor.dispatchCommand(STRIP_CITATIONS_COMMAND, undefined);
  }, [editor]);
};
